/*
 * Copy-link button in the blog sidebar share block.
 *
 * Copies the article URL from the button's data-copy-url and shows the
 * "copied" label in the sibling status line for a moment. Where the clipboard
 * API is unavailable (older browsers, non-secure origins) we fall back to a
 * prompt the reader can copy from by hand.
 *
 * The listener is delegated from the document, so it covers every share block
 * on the page and keeps working after the theme editor re-renders a section.
 */
(() => {
  const HIDE_AFTER = 2500;
  const timers = new WeakMap();

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-url]');
    if (!button) return;

    const root = button.closest('.blog-sidebar__share');
    const status = root && root.querySelector('.blog-sidebar__share-status');

    try {
      await navigator.clipboard.writeText(button.dataset.copyUrl);
    } catch (error) {
      window.prompt('Copy this link:', button.dataset.copyUrl);
      return;
    }

    if (!status) return;
    status.textContent = button.dataset.copiedLabel;
    clearTimeout(timers.get(status));
    timers.set(
      status,
      setTimeout(() => {
        status.textContent = '';
      }, HIDE_AFTER)
    );
  });
})();
